import { StatusChipText } from '@labrav/react-components'

import { ReportsRow } from '../../modules/revenueInsightsV2/types'

const hasAmountValue = (value?: string | null): boolean =>
  value != null && value !== '' && value !== 'NA'

const parseAmount = (value?: string | null): number => {
  if (!hasAmountValue(value)) {
    return 0
  }
  const amount = parseFloat(value as string)
  return Number.isFinite(amount) ? amount : 0
}

export const getCollectionStatusAndLabel = (reportRow: ReportsRow) => {
  const hasCollected = hasAmountValue(reportRow.collectedNetRevenue)
  const hasUncollected = hasAmountValue(reportRow.uncollectedNetRevenue)

  if (!hasCollected && !hasUncollected) {
    return { textColor: StatusChipText.RED, label: '-' }
  }

  const collected = parseAmount(reportRow.collectedNetRevenue)
  const uncollected = parseAmount(reportRow.uncollectedNetRevenue)

  if (collected === 0) {
    return { textColor: StatusChipText.RED, label: 'Not collected' }
  }

  if (uncollected === 0 && collected > 0) {
    return { textColor: StatusChipText.GREEN, label: 'Collected' }
  }

  return { textColor: StatusChipText.RED, label: '-' }
}
